import {
  Alert,
  Box,
  List,
  ListItem,
  ListItemText,
  Typography,
} from "@mui/material";
import t from "./translations";
import type { ObjectTypeMergeExecuteResult, RegionMergeResult } from "./schemas";

const STATUS_CONFIG: Record<
  RegionMergeResult["status"],
  { label: string; severity: "success" | "info" | "error" }
> = {
  merged: { label: t.StatusMerged, severity: "success" },
  already_merged: { label: t.StatusAlreadyMerged, severity: "info" },
  error: { label: t.StatusError, severity: "error" },
};

type Props = {
  result: ObjectTypeMergeExecuteResult;
};

export default function RegionResultList({ result }: Props) {
  return (
    <Box data-testid="objectTypeMerge.results">
      <Typography variant="h6" gutterBottom>
        {t.ResultsTitle}
      </Typography>
      <List disablePadding>
        {result.regions.map((region) => (
          <ListItem key={region.region} disableGutters sx={{ display: "block" }}>
            <Alert severity={STATUS_CONFIG[region.status].severity} sx={{ mb: 1 }}>
              <ListItemText
                primary={`${region.region} — ${STATUS_CONFIG[region.status].label}`}
                secondary={
                  region.status === "merged"
                    ? `${region.image_object_type_reassigned} reassigned, ${region.image_object_type_conflicts_removed} conflicts removed, ${region.qa_action_log_rows_written} QA log rows written`
                    : region.error
                }
              />
            </Alert>
          </ListItem>
        ))}
      </List>
    </Box>
  );
}
